import { connect } from 'react-redux'
import { rewritePanelSentencesSelector } from '@chegg-wt/core-wa/state/selectors'
import { AppState } from '@chegg-wt/core/state'
import MediaQuery from 'react-responsive'
import { breakpoints } from '@chegg-ui/theme'
import { SentenceOffset } from '@chegg-wt/core-wa/state/types'
import CardsContainer from '../CardsContainer/CardsContainer'
import EditorContainer from '../EditorContainer/EditorContainer'
import ProofReaderLeftPanel from '../ProofReaderLeftPanel/ProofReaderLeftPanel'
import { MENU_ITEM } from '../ProofReaderLeftPanel/type'
import { HeaderContainer } from '../HeaderContainer/HeaderContainer'
import QARightPanel from '../QuickActionRightPanel'
import { ToastPortal } from '../ToastNotification/ToastPortal'
import SmallScreenModalBlocker from '../SmallScreenModalBlocker'
import { AiPoweredDisclaimer } from '../EditorFooter/AiPoweredDisclaimer'
import {
  ProofReaderContentContainer,
  ProofReaderLayoutContainer,
  WorkspaceContainer,
} from './styled'

interface ProofReaderLayoutProps {
  rewritePanelSentences: SentenceOffset[]
}

const ProofReaderLayout = ({ rewritePanelSentences }: ProofReaderLayoutProps) => {
  return (
    <>
      <ProofReaderLayoutContainer>
        <HeaderContainer />
        <MediaQuery maxWidth={breakpoints.md.max}>
          <SmallScreenModalBlocker />
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.lg.min}>
          <ProofReaderContentContainer>
            <ProofReaderLeftPanel activeMenuItem={MENU_ITEM.WRITING} />
            <WorkspaceContainer>
              <EditorContainer isRewritePanelActive={rewritePanelSentences?.length > 0} />
              {rewritePanelSentences?.length > 0 ? <QARightPanel /> : <CardsContainer />}
            </WorkspaceContainer>
          </ProofReaderContentContainer>
          <AiPoweredDisclaimer className="undoRedo" />
        </MediaQuery>
      </ProofReaderLayoutContainer>
      <ToastPortal />
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  rewritePanelSentences: rewritePanelSentencesSelector(state),
})

export default connect(mapStateToProps)(ProofReaderLayout)
